import { platformRoleHasPermission } from "@/domain/platformPermissions";
import { usePlatformSessionStore } from "@/store/platformSession.store";

function usePlatformAccess() {
  const operator = usePlatformSessionStore((s) => s.operator);
  const roleId = operator?.roleId;
  const can = (permissionId) => {
    if (!operator) return false;
    if (Array.isArray(operator.permissions)) {
      return operator.permissions.includes(permissionId);
    }
    return platformRoleHasPermission(roleId, permissionId);
  };
  return {
    operator,
    roleId,
    can,
    isSignedIn: Boolean(operator),
  };
}

export { usePlatformAccess };
